import { useTranslation } from '@shared/core';
import { Flex, JoyKitThemeProvider, TooltipV2 } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';
import React from 'react';
import { StatusLabel } from './StatusLabel';

export const ReservationsCount = ({ reservationsCount }: { reservationsCount: number }) => {
  const { t } = useTranslation('guestSiteCustom');
  const accTrans = t('accommodations');
  return (
    <JoyKitThemeProvider>
      <TooltipV2
        overrides={{ Content: { props: { borderRadius: 6 } } }}
        content={
          <Flex flexDirection="column" maxWidth={pxToRem(256)}>
            <Flex typographyVariant={'label3'} color="white" fontWeight={700}>
              {accTrans.bookedTooltipTitle({ reservationsCount })}
            </Flex>
            <Flex typographyVariant={'label2'} color="white" fontWeight={400}>
              {accTrans.bookedTooltipBody()}
            </Flex>
          </Flex>
        }
      >
        <StatusLabel gap={3}>{reservationsCount === 1 ? accTrans.haveBookedOne({ reservationsCount }) : accTrans.haveBookedPlural({ reservationsCount })}</StatusLabel>
      </TooltipV2>
    </JoyKitThemeProvider>
  );
};
